/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("App is ready");
    },

    registered(registration) {
      console.log("Service worker registered");
      setInterval(() => registration.update(), 5 * 60 * 1000);
    },

    cached() {
      console.log("Content cached");
    },

    updatefound() {
      console.log("Update found");
    },

    updated() {
      console.log("New version available");
      if (window.showUpdateNotification) {
        window.showUpdateNotification();
      }
    },

    offline() {
      console.log("No internet connection");
    },

    error(error) {
      console.error("Service worker error:", error);
    },
  });
}
